import { postAction } from "../utils/request"

export function toLogin(data) {
  return postAction('/web/login',data)
}

